import React, { useEffect, useState } from "react";
import { serverNow } from "../lib/clock";

export function StageTimer({ deadline, className = "" }) {
  const [remaining, setRemaining] = useState(0);
  useEffect(() => {
    if (!deadline) { setRemaining(0); return; }
    const target = new Date(deadline).getTime();
    const tick = () => {
      // Use server-corrected clock so students' phones with skewed clocks stay in sync
      const ms = Math.max(0, target - serverNow());
      setRemaining(Math.ceil(ms / 1000));
    };
    tick();
    const i = setInterval(tick, 250);
    return () => clearInterval(i);
  }, [deadline]);
  return (
    <div className={`font-heading text-3xl font-bold tabular-nums ${className}`} data-testid="stage-timer">
      {remaining}s
    </div>
  );
}
